import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

const SetupSubscriptionPlanFragment = React.memo(() => {
    return <div className="mt-4 divide-gray-100 border-t border-b border-gray-200 py-6">
        <div className="rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10 bg-gray-50 sm:mx-8 lg:mx-0"><h3
            className="text-base font-semibold leading-7 text-blue-600">Starter Pack</h3><p
            className="mt-4 flex items-baseline gap-x-2"><span
            className="text-5xl font-bold tracking-tight text-gray-900">&euro;0.00</span><span
            className="text-base text-gray-500">/month</span></p><p
            className="mt-6 text-base leading-7 text-gray-600">The perfect plan if you're just getting started
            with
            our product.</p>
            <ul className="mt-8 sm:mt-10 grid grid-cols-1 gap-x-8 gap-y-3 lg:grid-cols-2 text-sm text-gray-600 leading-6">
                <li className="flex gap-x-3">
                    <CheckCircleIcon className="h-6 w-5 flex-none text-blue-600"/>
                    25 products
                </li>
                <li className="flex gap-x-3">
                    <CheckCircleIcon className="h-6 w-5 flex-none text-blue-600"/>
                    Up to 10,000 subscribers
                </li>
                <li className="flex gap-x-3">
                    <CheckCircleIcon className="h-6 w-5 flex-none text-blue-600"/>
                    Advanced analytics
                </li>
                <li className="flex gap-x-3">
                    <CheckCircleIcon className="h-6 w-5 flex-none text-blue-600"/>
                    24-hour support response time
                </li>
            </ul>
        </div>
    </div>

})

export default SetupSubscriptionPlanFragment;